import axios from 'axios';
import { useEffect, useState } from 'react';
import { BASE_URL } from '../../../insightConfig/insightConfig';
import Select from 'react-select'
import { Link } from 'react-router-dom';
import { SlArrowLeft } from "react-icons/sl";
import swal from 'sweetalert';


const NeetDashboard = () => {
    const [orders, setOrders] = useState([]);
    const [selectedOrders, setSelectedOrders] = useState([]);
    const [selecteSection, setSelectedSection] = useState('All Sections');
    const [selectedOrder, setSelectedOrder] = useState({});
    // let attempedTests = selectedOrder.CompletedTests + 1;
    const [tests, setTests] = useState([]);
    const [triggerUpdate, setTriggerUpdate] = useState(false);
    const { Sn, OrderID, ExamType = "neet", Duration, Marks_per_Question, Negative_Marking, QuestionCount, Subject, TestCount, CompletedTests, QuestionsToBeAttempted, Attempt, SubjectID } = selectedOrder;

    useEffect(() => {
        const fetchData = async () => {
            const response = await axios.get(BASE_URL + "/neet/user/my-tests-orders");
            setOrders(response?.data?.data);
            setSelectedOrders(response?.data?.data);
        }
        fetchData()
    }, [])

    useEffect(() => {
        if (Sn) {
            setTests(Array.from({ length: TestCount }, (_, i) => i + 1));
        }
    }, [Sn, triggerUpdate])

    const handleResetTest = (subjId, testNo, ordId) => {
        swal({
            title: "Are you sure?",
            text: "This will clear all your progress for this test.",
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                const allTestsReportsArray = JSON.parse(localStorage.getItem("NEET_TestSeriesReportArray")) || [];
                const updatedArray = allTestsReportsArray.filter(test =>
                    !(test.SubjectID === subjId && test.testNumber == testNo && test.orderId == ordId)
                );
                localStorage.setItem("NEET_TestSeriesReportArray", JSON.stringify(updatedArray));
                setTriggerUpdate(!triggerUpdate);
            }
        });
    };
    return (
        <>
            {
                !Sn ?
                    <div className="container-fluid px-2">
                        <div className="card shadow-sm">
                            <div className="d-flex justify-content-between align-items-center p-3 border-bottom flex-wrap gap-2">
                                <div className="flex-grow-1" style={{ maxWidth: '300px' }}>
                                    <Select
                                        id='select_test'
                                        value={{ value: selecteSection, label: selecteSection }}
                                        onChange={(selectedOption) => {
                                            setSelectedSection(selectedOption.value);
                                            if (selectedOption.value == 'All Sections') {
                                                setSelectedOrders(orders);
                                                return
                                            }
                                            setSelectedOrders(orders.filter((data) => {
                                                const sectionValue = data.Section || data.ExamType;
                                                const normalize = (str) => str?.toString().toLowerCase().replace(/[^a-z0-9]/g, '');
                                                return normalize(sectionValue) === normalize(selectedOption.value);
                                            }));
                                        }}
                                        options={['All Sections', 'Class-11', 'Class-12']?.map((item) => ({ value: item, label: item }))}
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                minWidth: '200px',
                                                backgroundColor: 'white',
                                                borderColor: '#17a2b8'
                                            })
                                        }}
                                    />
                                </div>
                                <div className="d-flex justify-content-end align-items-center">
                                    <Link
                                        to={'/neet/classes'}
                                        className='btn'
                                        style={{
                                            backgroundColor: '#28a745',
                                            color: 'white',
                                            padding: '8px 20px',
                                            borderRadius: '5px',
                                            fontWeight: 'bold',
                                            textDecoration: 'none',
                                            display: 'inline-block',
                                            boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                        }}
                                    >
                                        Purchase Tests
                                    </Link>
                                </div>
                            </div>
                            <div className="card-body mt-0 pt-2">
                                <div className="table-responsive">
                                    <table className="table table-bordered text-center">
                                        <thead>
                                            <tr>
                                                <th colSpan="5" style={{ backgroundColor: "#ff2f00" }} className="text-white fs-6">YOUR NEET ORDERS</th>
                                            </tr>
                                            <tr className="bg-light">
                                                <th>S No.</th>
                                                <th>Class</th>
                                                <th>Subject</th>
                                                <th>No. of Tests Enrolled</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedOrders?.map((course, index) => (
                                                <tr key={index} className='p-0'>
                                                    <td>{index + 1}</td>
                                                    <td className="text-primary fw-bold text-nowrap">{course.Section || course.ExamType || 'N/A'}</td>
                                                    <td>{course.Subject}</td>
                                                    <td>{course.TestCount}</td>
                                                    <td>
                                                        <button
                                                            className='btn btn-sm px-3'
                                                            style={{
                                                                backgroundColor: '#198754',
                                                                color: '#ffffff',
                                                                fontWeight: '600',
                                                                border: '1px solid #198754',
                                                                borderRadius: '4px',
                                                                minWidth: '80px',
                                                                cursor: 'pointer',
                                                                padding: '4px 16px',
                                                                fontSize: '14px'
                                                            }}
                                                            onClick={() => setSelectedOrder(course)}
                                                        >
                                                            Start
                                                        </button>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div> :
                    <div className='card p-2 pt-1 my-4 mx-2 shadow-lg'>
                        <div className="d-flex justify-content-between align-items-center p-2 py-1 bg-light border rounded shadow-sm">
                            <button
                                className="btn btn-sm"
                                style={{
                                    backgroundColor: '#17a2b8',
                                    color: 'white',
                                    fontWeight: 'bold',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '5px',
                                    padding: '4px 12px',
                                    border: 'none',
                                    borderRadius: '4px',
                                    boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
                                    cursor: 'pointer'
                                }}
                                onClick={() => setSelectedOrder({})}
                            >
                                <SlArrowLeft /> Back
                            </button>
                            <h2 className="mb-0 fs-5" style={{ color: 'rgb(183, 6, 6)', fontWeight: 600, letterSpacing: '0.5px', textShadow: '0 1px 1px rgba(0,0,0,0.1)', lineHeight: '1.2' }}>{Subject}</h2>
                            <span style={{ backgroundColor: "#6e1158" }} className="badge  text-white fs-6">Tests: {TestCount}</span>
                        </div>
                        {tests?.map((testData, index) => {
                            const testNumber = index + 1;
                            console.log(CompletedTests?.split(','));
                            let isAttempted = false;
                            let attemptCount = 0;
                            if (CompletedTests != '') {
                                isAttempted = testNumber <= CompletedTests?.split(',').length;
                                attemptCount = CompletedTests?.split(',')[testNumber - 1] || 0;
                            }

                            const inProgressArray = JSON.parse(localStorage.getItem("NEET_TestSeriesReportArray")) || [];
                            const isInProgress = inProgressArray.some(test =>
                                test.SubjectID === SubjectID && test.testNumber == testNumber && test.orderId == OrderID && !test.isTestFinished
                            );

                            // console.log(attemptCount, Attempt, isAttempted);
                            return (
                                < div key={index} className="d-grid gap-1 m-1 test-togglebackground" >
                                    <button className="toggle-button py-1">
                                        <div className="text-nowrap me-2 fw-medium">
                                            Test-{index + 1}
                                        </div>
                                        <div className='toggleheadingContainer me-3'></div>
                                        <div className='toggleheadingContainer me-3'>

                                        </div>
                                        <div className="d-flex justify-content-end align-items-center gap-1 w-75">
                                            {isAttempted ? (
                                                <div className="d-flex gap-1 w-100">
                                                    <Link
                                                        to={`/neet/online-exam/report`}
                                                        state={{ testDetails: { ...selectedOrder, exam_type: ExamType, testNumber: index + 1, orderId: OrderID, Duration: Duration, marksPerQuestion: Marks_per_Question, negativeMarking: Negative_Marking, questionLimit: QuestionCount, questionsToBeAttempted: QuestionsToBeAttempted } }}
                                                        className='list-group-item p-1 fw-bold bg-pureorange test-btn text-white w-50'
                                                    >
                                                        REPORT
                                                    </Link>
                                                    {Number(attemptCount) < Attempt && (
                                                        <Link
                                                            to={`/neet/online-exam/instructions`}
                                                            state={{ testDetails: { ...selectedOrder, exam_type: ExamType, testNumber: index + 1, orderId: OrderID, Duration: Duration, marksPerQuestion: Marks_per_Question, negativeMarking: Negative_Marking, questionLimit: QuestionCount, questionsToBeAttempted: QuestionsToBeAttempted, reAttempt: true } }}
                                                            className='list-group-item p-1 fw-bold bg-pureorange test-btn text-white w-50'
                                                        >
                                                            REATTEMPT
                                                        </Link>
                                                    )}
                                                </div>
                                            ) : (
                                                isInProgress ? (
                                                    <div className="d-flex gap-1 w-100">
                                                        <Link
                                                            to={`/neet/online-exam/live-test`}
                                                            state={{ testDetails: { ...selectedOrder, exam_type: ExamType, testNumber: index + 1, orderId: OrderID, Duration: Duration, marksPerQuestion: Marks_per_Question, negativeMarking: Negative_Marking, questionLimit: QuestionCount, questionsToBeAttempted: QuestionsToBeAttempted } }}
                                                            className='list-group-item p-1 fw-bold bg-pureorange test-btn text-white w-50'
                                                        >
                                                            RESUME
                                                        </Link>
                                                        <button
                                                            onClick={() => handleResetTest(SubjectID, testNumber, OrderID)}
                                                            className='list-group-item p-1 fw-bold bg-danger test-btn text-white w-50'
                                                            style={{ border: 'none' }}
                                                        >
                                                            RESET
                                                        </button>
                                                    </div>
                                                ) : (
                                                    <Link
                                                        to={`/neet/online-exam/instructions`}
                                                        state={{ testDetails: { ...selectedOrder, exam_type: ExamType, testNumber: index + 1, orderId: OrderID, Duration: Duration, marksPerQuestion: Marks_per_Question, negativeMarking: Negative_Marking, questionLimit: QuestionCount, questionsToBeAttempted: QuestionsToBeAttempted } }}
                                                        className='list-group-item p-1 fw-bold bg-pureorange test-btn text-white w-50'
                                                    >
                                                        START
                                                    </Link>
                                                )
                                            )}
                                        </div>

                                    </button>
                                </div>
                            )
                        }

                        )}
                    </div >
            }

        </>


    )
}

export default NeetDashboard